/**
 * Class description
 *
 * Created: 2018-04-20
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Linear, Power2, SlowMo, TimelineLite, TweenLite} from "gsap"
import {ParticleUtils} from "pixi-particles";
import {DungeonQuestLayerConfig} from "../../config/DungeonQuestLayerConfig";
import {DungeonQuestParticleConfig} from "../../config/DungeonQuestParticleConfig";
import {DungeonQuestTextStyles} from "../../config/DungeonQuestTextStyles";
import {MaskCreator} from "../../utils/MaskCreator";
import {ShakeUtil} from "../../utils/ShakeUtil";
import {DungeonQuestHelper} from "../bigSymbols/DungeonQuestHelper";
import {DualLayerBitmapCountUp} from "../display/DualLayerBitmapCountUp";
import {ShakeEffect} from "../display/effects/ShakeEffect";
import {TweenParticleEmitter} from "../display/TweenParticleEmitter";
import {DungeonQuest} from "../DungeonQuest";
import {DungeonQuestGameAssets} from "../DungeonQuestGameAssets";
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../DungeonQuestSound";
import {SparkRect} from "./parts/SparkRect";

export class DungeonQuestBigWinView extends BaseView {
    private _flare:PIXI.Sprite;
    private _plateContainer:PIXI.Container;
    // private _background:PIXI.Graphics;
    private _viewMask:PIXI.Graphics;
    private _plateParticles:PIXI.Sprite;
    private _sparkRect:SparkRect;

    get shakeEffect():ShakeEffect {
        if(!this._shakeEffect) {
            this._shakeEffect = ShakeUtil.createDefaultShake();
            //this._shakeEffect = new ShakeEffect([this._countUpText], new ShakeConfig());
        }
        return this._shakeEffect;
    }

    private _leftParticles:TweenParticleEmitter[];
    private _rightParticles:TweenParticleEmitter[];
    private _particleBackground:PIXI.Container;
    private _particleForeground:PIXI.Container;

    private _bigWinText:PIXI.Sprite;
    private readonly _textTextureNames:string[];
    private _particleAnimation:TimelineLite;
    private _countUpText:DualLayerBitmapCountUp;
    private _countContainer:PIXI.Container;
    private _shakeEffect:ShakeEffect;

    private _layer:ScalableLayer;

    constructor() {
        super();

        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.BIG_WIN.name);
        this._textTextureNames = [
            DungeonQuestGameAssets.BIG_WIN_BIG_WIN_TEXT,
            DungeonQuestGameAssets.BIG_WIN_MEGA_WIN_TEXT,
            DungeonQuestGameAssets.BIG_WIN_SUPER_MEGA_WIN_TEXT
        ];
    }

    protected initAnimations():void {
        this._layer.addChild(this);


        /*        this._background = MaskCreator.createSymbolAreaMaskGraphics(0, 0, DungeonQuestHelper.getDarkenColor(), 0.5);
                this._background.pivot.set(this._background.width * 0.5, 0);
                this._background.position.set(DungeonQuestGameConfig.instance.REEL_AREA_WIDTH * 0.5, 0);
                this._background.alpha = 0;*/

        const back = MaskCreator.createSymbolAreaMaskGraphics(0, 0, DungeonQuestHelper.getDarkenColor(), 0.5);
        back.pivot.set(back.width * 0.5, 0);
        back.position.set(DungeonQuestGameConfig.instance.REEL_AREA_WIDTH * 0.5, 0);
        back.alpha = 0;

        this.position.set(back.width * 0.5, back.height * 0.5);
        this.pivot.set(back.width * 0.5, back.height * 0.5);

        this._sparkRect = new SparkRect(back.width, back.height);

        this._viewMask = MaskCreator.createSymbolAreaMaskGraphics();
        this._viewMask.pivot.set(this._viewMask.width * 0.5, 0);
        this._viewMask.position.set(DungeonQuestGameConfig.instance.REEL_AREA_WIDTH * 0.5, 0);

        this._particleBackground = new PIXI.Container();
        this._particleBackground.name = "_particleBackground";

        this._particleForeground = new PIXI.Container();
        this._particleForeground.name = "_particleForeground";

        this.createParticles(this._particleBackground, this._particleForeground);

        //************* PLATE
        this._plateContainer = new PIXI.Container();
        this._plateContainer.position.set(0, 0);

        this._flare = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.BIG_WIN_FLARE)[0]);
        this._flare.blendMode = PIXI.BLEND_MODES.ADD;
        this._flare.anchor.set(0.5, 0.38);
        this._flare.position.set(360, 300);


        this._plateParticles = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.BIG_WIN_PLATE_PARTICLES)[0]);
        this._plateParticles.blendMode = PIXI.BLEND_MODES.ADD;
        this._plateParticles.anchor.set(0.5, 0.38);
        this._plateParticles.position.set(360, 300);

        this._bigWinText = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.BIG_WIN_BIG_WIN_TEXT)[0]);
        this._bigWinText.anchor.set(0.5, 0.5);
        this._bigWinText.position.set(360, 300);


        //*********Count up
        this._countContainer = new PIXI.Container();
        this._countUpText = new DualLayerBitmapCountUp(DungeonQuestTextStyles.BIG_WIN_DISPLAY_NUMBERS_WHITE, DungeonQuestTextStyles.BIG_WIN_DISPLAY_NUMBERS, 700, new PIXI.Point(0.5, 0.5));
        this._countUpText.getFadeOutTopLayer(0.001);

        this._countContainer.addChild(this._countUpText);
        this._countContainer.scale.set(0);
        this._countContainer.position.set(360, 550);


        //this.addChild(this._viewMask);

        //this.addChild(this._background);
        this.addChild(this._particleBackground);

        this.addChild(this._flare);

        this.addChild(this._plateParticles);
        this.addChild(this._bigWinText);
        this.addChild(this._particleForeground);

        this.addChild(this._countContainer);
        this.addChild(this._sparkRect);


        this.resetIntro();
    }

    private updateWinText(level:number) {
        this._bigWinText.texture = GameResources.getTextures(this._textTextureNames[level])[0];
    }

    private resetIntro() {
        this.scale.set(1, 1);
        this._flare.alpha = 0;
        this._flare.scale.set(0);
        this._plateParticles.alpha = 0;
        this._plateParticles.scale.set(0);
        this._bigWinText.scale.set(0);
        this._bigWinText.alpha = 0;
        //this._background.alpha = 0;
        this._countContainer.scale.set(0);

    }

    private getCountUpWhiteFlash(duration:number, startDurationFactor:number = 0.1, holdFactor:number = 0.3):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._countUpText.getFadeInTopLayer(duration * startDurationFactor));
        tl.add(this._countUpText.getFadeOutTopLayer(duration * (1 - startDurationFactor - holdFactor)), duration * holdFactor);
        return tl;
    }

    private getPumpStart(duration:number, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._bigWinText, duration * 0.5, {alpha : 1}),
            new TweenLite(this._bigWinText.scale, duration, {
                x : defaultScale * 0.80,
                y : defaultScale * 0.80,
                ease : Power2.easeIn
            }),
            new TweenLite(this._plateParticles, duration * 0.2, {alpha : 1}),
            new TweenLite(this._plateParticles.scale, duration, {
                x : defaultScale * 0.80,
                y : defaultScale * 0.80,
                ease : Power2.easeIn
            }),
            new TweenLite(this._flare, duration * 0.5, {alpha : 1}),
            new TweenLite(this._flare.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Power2.easeIn
            }),
            new TweenLite(this._countContainer, duration * 0.5, {alpha : 1}),
            new TweenLite(this._countContainer.scale, duration, {
                x : defaultScale * 0.9,
                y : defaultScale * 0.9,
                ease : Power2.easeIn
            })
        ]);
        return tl;
    }

    private getPumpMiddle(duration:number, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._bigWinText.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Linear.easeNone
            }),
            new TweenLite(this._plateParticles.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Linear.easeNone
            }),
            new TweenLite(this._flare.scale, duration, {
                x : defaultScale * 1.5,
                y : defaultScale * 1.5,
                ease : Linear.easeNone
            }),
            new TweenLite(this._countContainer.scale, duration, {
                x : defaultScale,
                y : defaultScale,
                ease : Linear.easeNone
            })
        ]);
        return tl;
    }

    private getPumpEnd(duration:number, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._countContainer.scale, duration, {
                x : defaultScale * 0.65,
                y : defaultScale * 0.65,
                ease : Power2.easeInOut
            }),
            new TweenLite(this._plateParticles, duration, {
                alpha : 0,
                ease : Power2.easeInOut
            })
        ]);


        tl.add([
            new TweenLite(this._bigWinText, 0.2, {alpha : 0.0, ease : Linear.easeNone}),
            new TweenLite(this._bigWinText.scale, 0.4, {
                x : defaultScale * 0.9,
                y : defaultScale * 0.9,
                ease : Power2.easeIn
            }),
            new TweenLite(this._flare, 0.2, {alpha : 0.0, ease : Linear.easeNone}),
            new TweenLite(this._flare.scale, 0.4, {
                x : 0,
                y : 0,
                ease : Power2.easeIn
            })
        ], "-=0.4");
        return tl;
    }

    private getPumpEndLast(endur:number, startDur:number, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        endur -= startDur;

        //Winndup
        tl.add([
            new TweenLite(this._countContainer.scale, endur, {
                x : defaultScale * 0.65,
                y : defaultScale * 0.65,
                ease : Power2.easeInOut
            }),
            new TweenLite(this._plateParticles, endur, {
                alpha : 0,
                ease : Power2.easeInOut
            })
        ]);
        tl.add([
            new TweenLite(this._bigWinText, 0.2, {alpha : 1.0, ease : Linear.easeNone}),
            new TweenLite(this._bigWinText.scale, 0.4, {
                x : defaultScale * 0.9,
                y : defaultScale * 0.9,
                ease : Power2.easeIn
            }),
            new TweenLite(this._flare, 0.2, {alpha : 0.0, ease : Linear.easeNone}),
            new TweenLite(this._flare.scale, 0.4, {
                x : 0,
                y : 0,
                ease : Power2.easeIn
            })
        ], "-=0.4");
        tl.add(() => this._bigWinText.scale.set(0));


        //Smash
        tl.add([
            new TweenLite(this._bigWinText, startDur * 0.5, {alpha : 1}),
            new TweenLite(this._bigWinText.scale, startDur, {
                x : defaultScale,
                y : defaultScale,
                ease : Power2.easeIn
            }),
            new TweenLite(this._plateParticles, startDur * 0.2, {alpha : 1}),
            new TweenLite(this._plateParticles.scale, startDur, {
                x : defaultScale,
                y : defaultScale,
                ease : Power2.easeIn
            }),
            new TweenLite(this._flare, startDur * 0.5, {alpha : 1}),
            new TweenLite(this._flare.scale, startDur, {
                x : defaultScale,
                y : defaultScale,
                ease : Power2.easeIn
            }),
            new TweenLite(this._countContainer, startDur * 0.5, {alpha : 1}),
            new TweenLite(this._countContainer.scale, startDur, {
                x : defaultScale,
                y : defaultScale,
                ease : Power2.easeIn
            })
        ]);
        return tl;
    }

    private getPumpAnimation(duration:number, level:number, lastLevel:boolean, defaultScale:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let startDur:number = level == 0 ? 0.4 : 0.1;
        let endDur:number = lastLevel ? 0 : 1.87; //Last level don't have ending. //3.740 when filter sweep begins.
        let middleDur:number = duration - startDur - endDur;


        tl.add(() => this.updateWinText(level));
        tl.add(() => this._bigWinText.scale.set(0));
        tl.add(() => this._plateParticles.scale.set(0));
        tl.add(this.getPumpStart(startDur, defaultScale));

        const landingTime:number = tl.totalDuration();

        tl.add([
            this.getPumpMiddle(middleDur, defaultScale),
            this._sparkRect.getSparkAnimation(middleDur, level)
        ]);

        tl.add([
            () => this.getCountUpWhiteFlash(1),
            this.shakeEffect.getOneShotShake(0.3),
            () => DungeonQuest.soundPlayer.switchToBigWinMusic(),
            () => SlotGame.sound.playEffect(DungeonQuestSound.BIG_WIN_LAND)
        ], landingTime);


        if(!lastLevel) {
            tl.add(this.getPumpEnd(endDur, defaultScale));
            tl.add(() => this._particleAnimation = this.getParticleAnimation(4, level + 1), "-=0.3");
        }

        tl.add(DungeonQuest.reelAreaEffectController.fadeInDarkenPlate(middleDur), landingTime);


        return tl;
    }

    public getBigWinLevelAnimation(level:number, lastLevel:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        let pumpDur:number = 0;
        //let eightBarLength:number = 7.48;
        const barLength = 0.935;
        switch(level) {
            case 0:
                // 0.4 => Longer pump start, music start after pump start.
                // - 0.1 => Start time for the next level.
                pumpDur = 0.4 + barLength * 8 - 0.1;
                break;
            case 1:
                pumpDur = barLength * 8;
                break;
            case 2:
                pumpDur = barLength * 8;
                break;
            default:
                pumpDur = 0;
                break;

        }

        if(level == 0) {
            tl.add(() => this._particleAnimation = this.getParticleAnimation(4, level));
        }

        tl.add([
            this.getPumpAnimation(pumpDur, level, lastLevel, 0.9)
        ]);

        if(lastLevel) {
            tl.add(DungeonQuest.reelAreaEffectController.fadeOutDarkenPlate(0.5), "-=0.5");
        }
        //console.log("SOUND: Level: "+ level + " Time:" + tl.totalDuration());
        return tl;
    }

    public getCountUp(from:number, to:number, duration:number):TimelineLite {
        return this._countUpText.getCountAnimation(from, to, duration);
    }


    public getSetToEndStateAnimation(level:number, totalAmount:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => DungeonQuest.soundPlayer.switchToPreBigWinMusic(),
            () => SlotGame.sound.playEffect(DungeonQuestSound.BIG_WIN_END)
        ]);
        tl.add([
            () => this._countUpText.stopAt(totalAmount),
            // () => DungeonQuest.soundPlayer.stopCountUp(false),
            () => this.updateWinText(level),

        ]);

        const dur = 0.15;
        tl.add([
            () => this.getCountUpWhiteFlash(1),
            DungeonQuest.reelAreaEffectController.fadeOutDarkenPlate(dur),
            // new TweenLite(this._background, dur, {alpha : 0, ease : Linear.easeOut}),
            new TweenLite(this._bigWinText, dur, {alpha : 1, ease : Linear.easeOut}),
            new TweenLite(this._countContainer, dur, {alpha : 1, ease : Linear.easeOut}),
            new TweenLite(this._flare, dur, {alpha : 1, ease : Linear.easeOut}),

            new TweenLite(this._bigWinText.scale, dur, {x : 1, y : 1, ease : Power2.easeIn}),
            new TweenLite(this._flare.scale, dur, {x : 1.5, y : 1.5, ease : Power2.easeIn}),
            new TweenLite(this._countContainer.scale, dur, {x : 1, y : 1, ease : Power2.easeIn})
        ]);

        return tl;
    }

    public getFadeOutAllAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let dur = 1;
        const scale = 1.1;

        tl.add(new TweenLite(this.scale, dur, {x : scale, y : scale, ease : Linear.easeNone}));

        dur *= 0.5;
        tl.add([
            new TweenLite(this._bigWinText, dur, {alpha : 0, ease : Power2.easeIn}),
            new TweenLite(this._flare, dur, {alpha : 0, ease : Power2.easeIn}),
            new TweenLite(this._countContainer, dur, {alpha : 0, ease : Power2.easeIn})
        ], dur);

        return tl;
    }

    public getEndingAnimation(isAborted:boolean, level:number, totalAmount:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(isAborted) {
            if(this._particleAnimation && this._particleAnimation.isActive()) {
                this._particleAnimation.timeScale(3);
            }
        }

        const delay:number = isAborted ? 0.1 : 0.0;
        tl.add(() => this._sparkRect.clearSparks());
        tl.add(this.getSetToEndStateAnimation(level, totalAmount));
        tl.add(this.getFadeOutAllAnimation(), delay);
        tl.add(() => this.resetIntro());
        tl.add(() => this.shakeEffect.stopShake());

        return tl;
    }

    private createParticles(background:PIXI.Container, foreground:PIXI.Container) {
        const particleTextures = [
            GameResources.getTextures(DungeonQuestGameAssets.BW_PARTICLE_1)[0],
            GameResources.getTextures(DungeonQuestGameAssets.BW_PARTICLE_2)[0],
            GameResources.getTextures(DungeonQuestGameAssets.BW_PARTICLE_3)[0],
            GameResources.getTextures(DungeonQuestGameAssets.BW_PARTICLE_4)[0]
        ];

        this._leftParticles = [];
        this._rightParticles = [];
        const emitterCount:number = 3;
        for(let i:number = 0; i < emitterCount; i++) {
            DungeonQuestParticleConfig.leftBigWinParticleConfigs[i].pos.x = -DungeonQuestGameConfig.instance.REEL_AREA_WIDTH * 0.5;
            DungeonQuestParticleConfig.leftBigWinParticleConfigs[i].pos.y = DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT;
            DungeonQuestParticleConfig.leftBigWinParticleConfigs[i].scale.start = 0.5 + (0.1 * i);
            DungeonQuestParticleConfig.leftBigWinParticleConfigs[i].scale.end = 0.5 + (0.1 * i);
            const left:TweenParticleEmitter = new TweenParticleEmitter(particleTextures, DungeonQuestParticleConfig.leftBigWinParticleConfigs[i]);

            DungeonQuestParticleConfig.rightBigWinParticleConfigs[i].pos.x = DungeonQuestGameConfig.instance.REEL_AREA_WIDTH * 1.5;
            DungeonQuestParticleConfig.rightBigWinParticleConfigs[i].pos.y = DungeonQuestGameConfig.instance.REEL_AREA_HEIGHT;
            DungeonQuestParticleConfig.rightBigWinParticleConfigs[i].scale.start = 0.5 + (0.1 * i);
            DungeonQuestParticleConfig.rightBigWinParticleConfigs[i].scale.end = 0.5 + (0.1 * i);
            const right:TweenParticleEmitter = new TweenParticleEmitter(particleTextures, DungeonQuestParticleConfig.rightBigWinParticleConfigs[i]);

            this._leftParticles.push(left);
            this._rightParticles.push(right);

            if(i > emitterCount * 0.5) {
                foreground.addChild(left);
                foreground.addChild(right);
            } else {
                background.addChild(left);
                background.addChild(right);
            }
        }
    }

    private getParticleAnimation(countDuration:number, level:number):TimelineLite {
        const maxParticles = (level + 1);

        let tl:TimelineLite = new TimelineLite();

        for(let i:number = 0; i < this._leftParticles.length; i++) {
            const depthMaxCount = maxParticles * (this._leftParticles.length - i);
            let leftParticle = this._leftParticles[i];
            let rightParticle = this._rightParticles[i];

            tl.add(() => this.setParticlesProperty(i, level, depthMaxCount), 0);
            tl.add(() => leftParticle.start(SlowMo.ease.config(0.3, 0.8, false)), 0.3);
            tl.add(() => rightParticle.start(SlowMo.ease.config(0.3, 0.8, false)), 0.3);
        }
        tl.add(()=> countDuration - 0.7 + 0.3);

        return tl;
    }

    private setParticlesProperty(index:number, level:number, maxParticles:number) {
        let baseScale:number;
        let depthFactor:number;
        let startColor:string;
        let endColor:string;
        let endScaleFactor:number;

        switch(level) {
            case 0:
                baseScale = 0.3;

                break;
            case 1:
                baseScale = 0.3;

                break;
            default:
                baseScale = 0.3;

        }

        startColor = "#aea2bf";
        switch(index) {
            case 0:
                endColor = "#9b88d7";
                startColor = "#9b88d7";
                depthFactor = 1;
                endScaleFactor = 0.8;
                break;
            case 1:
                startColor = "#aea2bf";
                endColor = startColor;
                depthFactor = 1;
                endScaleFactor = 1.5;
                break;
            default:
                startColor = "#ffffff";
                endColor = "#ffffff";
                depthFactor = 1;
                endScaleFactor = 2.5;
        }

        const startScale = baseScale * depthFactor;
        const endScale = startScale * endScaleFactor;

        this._leftParticles[index].emitterConfig.color.start = startColor;
        this._leftParticles[index].emitterConfig.color.end = endColor;
        this._leftParticles[index].emitterConfig.scale.start = startScale;
        this._leftParticles[index].emitterConfig.scale.end = endScale;
        this._leftParticles[index].emitterConfig.maxParticles = maxParticles;
        this._leftParticles[index].updateConfig();

        this._rightParticles[index].emitterConfig.color.start = startColor;
        this._rightParticles[index].emitterConfig.color.end = endColor;
        this._rightParticles[index].emitterConfig.scale.start = startScale;
        this._rightParticles[index].emitterConfig.scale.end = endScale;
        this._rightParticles[index].emitterConfig.maxParticles = maxParticles;
        this._rightParticles[index].updateConfig();
    }

    public preCalculateCountScale(totalWin:number) {
        this._countUpText.preCalculateScale(0, totalWin);
    }
}